<div [formGroup]="gastroService.gastroForm">
    <div *ngIf="pathologyError" class="print-history-popup">
        <div class="print-history-popup-body">
            <h2 class="popup-title">{{!gastroService.gastroForm.get('Reasone').value ? 'Exam Indication cannot be empty' : 'No samples have been taken for this exam'}} </h2>
            <button (click)="pathologyError=false" class="print-history-popup-close" aria-label="close popup"></button>
        </div>
    </div>
    <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">
        <div style="width: 50%">
            <section class="m-box" style="height: 100%;margin-top: auto;">
                <h2 style="top: -3.2em;">Diagnosis</h2>
                <label>Diagnosis search: </label>
                <mat-form-field style="width: 50%; margin-left: 2em;margin-top: 0;">
                    <input #inputDiagnosis type="text"
                            id="inputDiagnosis"
                           matInput
                           class="t-field t-select" 
                           style="height: 2em;padding: 0 0 0 1em;"
                           [formControl]="search"
                           [matAutocomplete]="auto">
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"  >
                        <mat-option [value]="search.value" (onSelectionChange)="addToList(search, true);reset();blur();" >{{search.value}}</mat-option>
                      <div *ngFor="let option of filteredOptions | async;" style="display: flex;">                          
                        <!-- <mat-option style="width:100%"  [value]="option.value" (onSelectionChange)="gastroService.saveDiagnosis(option);reset();blur()"> -->
                        <mat-option style="width:100%"  [value]="option.value" (onSelectionChange)="addToList(option, false);reset();blur()">

                            {{option.value}}
                        </mat-option>
                      </div>
                    </mat-autocomplete>
                </mat-form-field>
                <ng-container *ngIf="gastroService.diagnosis && gastroService.diagnosis.length > 0">
                <hr *ngIf="gastroService.diagnosis && gastroService.diagnosis.length > 0">
                    <table>
                        <tr *ngFor="let diag of gastroService.diagnosis;index as i" style="cursor: pointer;" (dblclick)="gastroService.deleteDiagnosis(i)" matTooltip="Double Click To Remove">
                            <td class="l-td-m">{{i+1}}.</td>
                            <td class="l-td-m">{{diag.value}}</td>
                        </tr>
                    </table>
                </ng-container>
            </section>
        </div>
        <div style="width: 50%; height: auto;">
            <section class="m-box" style="height: 100%;">
                <h2>Diagnosis Comments</h2>
                <textarea class="fulltext" #Diagnosis name="Diagnosis" id="Diagnosis" style="min-height: 70px;height: 100%;" formControlName="Diagnosis"></textarea>
                <button class="t-btn-edit" *ngIf="! es.isClosed"
                    (click)="atS.showAuto(gastroService.gastroForm.get('Diagnosis'),'Diagnosis',113)">Auto Text</button>
            </section>
        </div>
    <ng-container *ngIf="es.ExamType !== 'Abdomen US'">
        <div style="width: 100%;">
            <section class="m-box">
                <h2>Recovery Comments</h2>
                <textarea class="fulltext" style="min-height: 70px;" formControlName="Recovery"></textarea>
                <button class="t-btn-edit" *ngIf="! es.isClosed"
                    (click)="atS.showAuto(gastroService.gastroForm.get('Recovery'),'Recovery',209)">Auto Text</button>
            </section>
        </div>
        <div style="width: 100%;">
            <section class="m-box">
                <h2>Dissmission Instructions</h2>
                <textarea class="fulltext" style="min-height: 7em;" formControlName="Dissmission"></textarea>
                <button class="t-btn-edit" *ngIf="! es.isClosed"
                    (click)="atS.showAuto(gastroService.gastroForm.get('Dissmission'),'Dissmission Instructions',204)">Auto Text</button>
            </section>
        </div>
        <div style="width: 100%;">
            <section class="m-box">
                <h2>Recommendations</h2>
                <textarea class="fulltext" style="min-height: 70px;" formControlName="Recomm"></textarea>
                <button class="t-btn-edit" *ngIf="! es.isClosed"
                    (click)="atS.showAuto(gastroService.gastroForm.get('Recomm'),'Recommendations',114)">Auto Text</button>
            </section>
        </div>
        <div *ngIf="es.ExamType !== 'Hemorrhoids Treatment'" style="width: 100%;display: inline-flex;">
            <div class="summary-boxHeight summary-referringDr" [ngClass]="ls.userType==='secretary'? 'w170':'w50'" style="padding: 0 1em 0 0;">
                <section class="m-box" [ngStyle]="ls.userType==='secretary'?{'height': '120%'} : {'height': '108%'}"  [formGroup]="gastroService.awlForm" [ngClass]="es.loadedFromLabResults == 'needsPayer' ? 'needs-payer-highlight' : ''">
    
                    <h2>
                        HMO
                    </h2>
                    <div class="l-flex-c l-flex-w indicative-fieldset ">
                        <label class="t-label">
    
                            <input type="radio" formControlName="HMO" value="Leumit" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                Leumit
                            </span>
    
                        </label>
    
                        <label class="t-label">
                            <input type="radio" formControlName="HMO" value="Clalit" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                Clalit
                            </span>
                        </label>
    
                        <label class="t-label">
                            <input type="radio" formControlName="HMO" value="Macabi" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                Macabi
                            </span>
                        </label>
    
                        <label class="t-label">
                            <input type="radio" formControlName="HMO" value="Meuhedet" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                Meuhedet
                            </span>
                        </label>
                        <label class="t-label">
                            <input type="radio" formControlName="HMO" value="Private" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                Private
                            </span>
                        </label>
                        <br>
                        <label class="t-label">
                            <input type="radio" formControlName="HMO" value="הפניקס" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                הפניקס
                            </span>
                        </label>
                        <label class="t-label">
                            <input type="radio" formControlName="HMO" value="כלל" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                כלל
                            </span>
                        </label>
                        <label class="t-label">
                            <input type="radio" formControlName="HMO" value="איילון" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                איילון
                            </span>
                        </label>
                        <label class="t-label">
                            <input type="radio" formControlName="HMO" value="הכשרה ביטוח" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                הכשרה ביטוח
                            </span>
                        </label>
                    </div>
                    <div style=" display: flex;
                    flex-direction: row;">
                    <div style="display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    margin-top: 1em ;
                    width: 120%
                    " *ngIf="ls.userType=='secretary'">
                    <div class="w50" *ngIf="gastroService.awlForm.get('HMO').value == 'Macabi' ||gastroService.awlForm.get('HMO').value == 'Leumit' || gastroService.awlForm.get('HMO').value== 'Meuhedet' ||gastroService.awlForm.get('HMO').value == 'Clalit'">

						<div class="l-flex l-flex-c t-field t-field-pad input" >

                            <label matTooltip="מס. התחייבות" *ngIf="gastroService.awlForm.get('HMO').value == 'Macabi' || gastroService.awlForm.get('HMO').value == 'Meuhedet'">
                                מספר התחייבות
                            </label>
							<label matTooltip="מס. הפניה"  *ngIf="gastroService.awlForm.get('HMO').value  == 'Clalit' || gastroService.awlForm.get('HMO').value == 'Leumit'">
								קוד הזמנה/הפניה 
							</label>

							<i class="t-sep"></i>

							<span class="t-validation-wrap l-fg1" >
								<input type="number"   [formControlName]="secondCommitment() ? 'PRN2' : 'PRN'"
                                class="t-field-text w100"  />
								
							</span>
							
						</div>
						
					</div>
					
					<div class="w50" *ngIf="gastroService.awlForm.get('HMO').value== 'Macabi' || gastroService.awlForm.get('HMO').value == 'Clalit' || gastroService.awlForm.get('HMO').value == 'Leumit'" >

						<div class="l-flex l-flex-c t-field t-field-pad input" matTooltip=" רשיון רופא/זיהוי מזמין">
							<label *ngIf="gastroService.awlForm.get('HMO').value == 'Clalit' || gastroService.awlForm.get('HMO').value == 'Leumit'" >
								רשיון רופא/זיהוי מזמין
							</label>
                            <label *ngIf=" gastroService.awlForm.get('HMO').value == 'Macabi'">
								מס. רופא מפנה
							</label>
							

							<i class="t-sep"></i>
							<span class="t-validation-wrap l-fg1">
								<input type="number" [formControlName]="secondCommitment()  ? 'Code2' : 'Code'"  class="t-field-text w100" />
								<div class="t-validation-message">
									<span>Invalid Doctor ID</span>
								</div>
							</span>
							
						</div>
						
					</div>
					<div class="w50"  *ngIf="gastroService.awlForm.get('HMO').value == 'Macabi' || gastroService.awlForm.get('HMO').value == 'Clalit' || gastroService.awlForm.get('HMO').value == 'Leumit'"  >

						<div class="l-flex l-flex-c t-field t-field-pad input" matTooltip="שם פרטי המזמין">
							<label *ngIf="gastroService.awlForm.get('HMO').value == 'Macabi'">
								 שם רופא מפנה
							</label>
                            <label *ngIf="gastroService.awlForm.get('HMO').value == 'Clalit' || gastroService.awlForm.get('HMO').value == 'Leumit'">
                                שם פרטי רופא מזמין 
                           </label>

							<i class="t-sep"></i>
							<span class="t-validation-wrap l-fg1">
								<input type="text" [formControlName]="secondCommitment()  ? 'refDocName2' : 'refDocName'"  class="t-field-text w100" />
								<div class="t-validation-message">
									<span>Invalid Doctor ID</span>
								</div>
							</span>
							
						</div>
						
					</div>
					<div class="w50"   *ngIf="gastroService.awlForm.get('HMO').value  == 'Clalit' || gastroService.awlForm.get('HMO').value == 'Leumit'">

						<div class="l-flex l-flex-c t-field t-field-pad input" matTooltip="שם משפחה המזמין">
							<label>
								 שם משפחה רופא מזמין
							</label>

							<i class="t-sep"></i>
							<span class="t-validation-wrap l-fg1">
								<input type="text" [formControlName]="secondCommitment()  ? 'refDocLastName2' : 'refDocLastName'"  class="t-field-text w100" />
								<div class="t-validation-message">
									<span>Invalid Doctor ID</span>
								</div>
							</span>
							
						</div>
						
					</div>
					<div class="w50" *ngIf="gastroService.awlForm.get('HMO').value  == 'Clalit' || gastroService.awlForm.get('HMO').value == 'Leumit'">

						<div class="l-flex l-flex-c t-field t-field-pad input" matTooltip=" קוד מרפאה">
							<label>
								  קוד מרפאה  
							</label>

							<i class="t-sep"></i>
							<span class="t-validation-wrap l-fg1">
								<input type="number" [formControlName]="secondCommitment() ? 'BranchProviderID2' : 'BranchProviderID'"  class="t-field-text w100" />
								<div class="t-validation-message">
									<span>Invalid Doctor ID</span>
								</div>
							</span>
							
						</div>
						
					</div>
					<div class="w50" *ngIf="gastroService.awlForm.get('HMO').value  == 'Clalit' || gastroService.awlForm.get('HMO').value == 'Leumit'">

						<div class="l-flex l-flex-c t-field t-field-pad input" matTooltip="גורם שולח">
							<label>
								    גורם שולח
							</label>

							<i class="t-sep"></i>
							<span class="t-validation-wrap l-fg1">
								<input type="text" [formControlName]="secondCommitment()  ? 'BranchProviderName2' : 'BranchProviderName'"  class="t-field-text w100" />
								<div class="t-validation-message">
									<span>Invalid Doctor ID</span>
								</div>
							</span>
							
						</div>
						
					</div>
					

					
				</div>
                <div *ngIf="(gastroService.awlForm.get('HMO').value  == 'Clalit' || gastroService.awlForm.get('HMO').value == 'Leumit') && ls.userType==='secretary'">

                        <label class="observe" style="margin: 2em;">

                            <input type="radio" class="custom-check customInput" [(ngModel)]="xmlMode" name="xmlModeGroup" [ngModelOptions]="{standalone: true}"  value="1"><i
                                class="customInput-display"></i>

                            <span>
                                New
                            </span>
                        </label>

                        <label class="not-observed">

                            <input type="radio" class="custom-check customInput"  [(ngModel)]="xmlMode" name="xmlModeGroup"  [ngModelOptions]="{standalone: true}" value="2"><i
                                class="customInput-display"></i>

                            <span>
                                Update 
                            </span>

                        </label>
                        <label class="not-observed">

                            <input type="radio" class="custom-check customInput" [(ngModel)]="xmlMode" name="xmlModeGroup" [ngModelOptions]="{standalone: true}"  value="3"><i
                                class="customInput-display"></i>

                            <span>
                                Cancel 
                            </span>

                        </label>
                        <button class="search-btn search-btn--newPatient" style="margin: 1em 4em ;width: 50%;" (click)="downloadXml()" [disabled]="!xmlMode|| xmlLoading" matTooltip="Build and Download xml">Build and Download </button>
                        <!-- <img *ngIf="xmlLoading" src="../../assets/images/Wedges.svg"> -->
                </div>
                </div>
    
                </section>
            </div>
            <div class="w50 summary-referringDr" style="padding: 0 0 0 1em;">
                <section class="m-box padd" style="height: 30%;" (dblclick)="gastroService.gastroForm.get('ReffDoc').setValue(-1)">
                    <h2>Referring Doctor</h2>
                    <textarea class="fulltext minH4" formControlName="ReffDoc" ></textarea>
                </section>
                <section class="m-box padd" style="height: 50%;" (dblclick)="gastroService.gastroForm.get('ProcedureResult').setValue(null)">
                    <h2>Procedure Results</h2>
                    <div class="l-flex-c l-flex-w indicative-fieldset h100">
                        <label class="t-label-top">
    
                            <input type="radio" formControlName="ProcedureResult" value="No Clinical Findings" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                No Clinical Findings
                            </span>
    
                        </label>
    
                        <label class="t-label-top">
                            <input type="radio" formControlName="ProcedureResult" value="Clinical Findings" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                Clinical Findings
                            </span>
                        </label>
    
                        <label class="t-label-top">
                            <input type="radio" formControlName="ProcedureResult" value="Urgent Clinical Findings" class="custom-check -sq" />
                            <i class="customInput-display -sq"></i>
                            <span>
                                Urgent Clinical Findings
                            </span>
                        </label>
                    </div>
                </section>
            </div>
        </div>
    </ng-container>
        <!-- =============== Exam Signature (Start) =============== -->
        <div class="w50 summary-boxHeight summary-referringDr" [ngStyle]="(es.ExamType === 'Abdomen US' || es.ExamType === 'Hemorrhoids Treatment') ? {'margin':'auto'}:''">
            <section class="m-box">
                <h2>
                    Sign Exam
                </h2>
                <div class="l-flex-c l-flex-w indicative-fieldset h100">
                    <button class="save_patieont"
                        *ngIf="ls.userType === 'doctor' && !showPrintOpts && !signatureService.isExamSigned(es.examObject)"
                        (click)="showPrintOpts = true">
                        Sign Exam as {{ls.getUserName()}}
                    </button>
                
                    <span *ngIf="signatureService.isExamSigned(es.examObject)">
                        Signed on {{es.examObject.SignedDate | date:'d-M-y H:mm:ss'}} by {{es.examObject.SignedBy}}
                    </span>
                </div>
            </section>
        </div>
        <!-- =============== Exam Signature (End) =============== -->
        <div *ngIf="ls.userType!=='secretary' && ls.userType!=='nurse'&& es.ExamType !== 'Abdomen US' && es.ExamType !== 'Hemorrhoids Treatment'" class="w50 summary-boxHeight summary-referringDr">
            <section class="m-box">
                
                <div class="l-flex-c l-flex-w indicative-fieldset h100">
                    <button class="save_patieont"
                    [disabled]="!pathologyService.pathologies || pathologyService.pathologies.length === 0"
                        (click)="printPathologyForm()">
                        Print Pathologies Form
                    </button>
                
                </div>
            </section>
        </div>
    </div>
</div>
 
<app-printopts *ngIf="showPrintOpts" (closed)="closePreview($event)" [showopts]="false" [signature]="true"></app-printopts>